import { ContentApi } from '@/api/content'

export { default as bookApi } from '@/api/book'
export { default as collectionApi } from '@/api/collection'
export { default as configurationApi } from '@/api/configuration'
export const bookContentApi = new ContentApi('bookContent')
export { default as dashboardApi } from '@/api/dashboard'
export { default as menuApi } from '@/api/menu'
export { default as orderApi } from '@/api/order'
export { default as pageApi } from '@/api/page'
export const pageContentApi = new ContentApi('pageContent')
export { default as profileApi } from '@/api/profile'
export { default as sessionApi } from '@/api/session'
export { default as userApi } from '@/api/user'
